var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"connection-dot",class:_vm.connected ? 'connection-dot-connected' : 'connection-dot-disconnected',attrs:{"role":"img","aria-label":_vm.label,"title":_vm.label}})}
var staticRenderFns = []

export { render, staticRenderFns }